import { useEffect, useMemo } from 'preact/hooks'
import { useOptionsSync } from './useOptionsSync'
import { useSearchspringContext } from '../fetchers/provider'

export function useOption(key, _options = {}) {
  const { defaultValue, syncWithURL = false } = _options

  const { options } = useSearchspringContext()
  const { setOptionToURL, getOptionFromURL } = useOptionsSync()

  const option = useMemo(() => {
    return options.get(key) ?? defaultValue
  }, [options])

  useEffect(() => {
    if (syncWithURL) getOptionFromURL(key)
  }, [])

  useEffect(() => {
    if (syncWithURL) setOptionToURL(key)
  }, [option])

  return option
}
